import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import { DropTarget } from 'react-dnd';
import { PMDNDTypes, WIN_SIZE_MIN } from "./constants";
import Scaffolds from "./Scaffolds";

class ScaffoldDesktop extends Component {
	state = {
		isLoading: false,
	}

	funcRemoveWindow = (index) => {
		console.log("[ScaffoldDesktop] rmv window ", index);
		let newState = Object.assign({}, this.state);
		let tasks = newState.storedScaffolds;
		tasks[index].hidden = true;
		this.setState({ storedScaffolds: tasks });
	}

	funcResize = (index) => {
		console.log("[ScaffoldDesktop] TODO resize window ", index);
	}

	funcLock = (index) => {
		console.log("[ScaffoldDesktop] TODO funcLock ", index);
	}

	funcHandleChange = (index, findex, event) => {
		console.log("[ScaffoldDesktop] TODO funcHandleChange ");
		let scaffs = this.props.reduxData.storedScaffolds.slice();
		scaffs[index].fields[findex].value = event.target.value;
		this.props.updateScaffold(scaffs);
	}

	funcMoveWindow = (index, x, y) => {
		console.log("[ScaffoldDesktop] move window ", index);
		let scaffs = this.props.reduxData.storedScaffolds.slice();
		scaffs[index].window.xLeft = Math.round(x / 16) * 16;
		scaffs[index].window.yTop = Math.round(y / 16) * 16;
		scaffs[index].window.zIndex = this.props.reduxData.storedScaffolds[index].window.zIndex + 1;
		this.props.updateScaffold(scaffs);
	}

	componentWillMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;

		this.setState(function () {
			return {
				isLoading: true,
			}
		});

		this.setState(function () {
			return {
				isLoading: false,
				storedScaffolds: p.reduxData.storedScaffolds
			}
		});

	}

	render() {
		const { connectDropTarget, hovered } = this.props;
		const { isLoading, storedScaffolds } = this.state;
		const startOver = this.startOver;
		const build = this.build;
		const addNewTask = this.addNewTask;
		const funcResize = this.funcResize;
		const funcRemoveWindow = this.funcRemoveWindow;
		const selectEditTask = this.selectEditTask;
		const funcLock = this.funcLock;
		const funcHandleChange = this.funcHandleChange;

		const pmProps = {
			isLoading,
			storedScaffolds,
			startOver,
			build,
			addNewTask,
			funcResize,
			funcRemoveWindow,
			selectEditTask,
			funcLock,
			funcHandleChange
		}

		return connectDropTarget(
			<div className={"ScaffoldDesktop" + (hovered === true ? " PMHoverOld" : "")}>
				<Scaffolds
					{...pmProps}
				/>
			</div>
		);
	}



	build = () => {
		const { setRoute } = this.props;
		console.log('BUILD TODO')
	}

}


const dropSource = {
	drop: function (props, monitor, component) {
		const item = monitor.getItem();
		//console.log(item); // dragging
		//console.log(component); //drop target
		//console.log(monitor);

		//if (monitor.isOver()) {
		//	console.log("monitor.isOver");
		//}

		const started = monitor.getInitialClientOffset();
		const sub = monitor.getInitialSourceClientOffset();
		const delta = monitor.getDifferenceFromInitialOffset();
		const calc_x = delta.x + (sub.x);
		const calc_y = delta.y + (sub.y);

		component.funcMoveWindow(item.index, calc_x, calc_y);
	},
	//hover: function (props, monitor, component) {
	//	console.log("hovering over background");
	//}
}

function dropCollect(connect, monitor) {
	//console.log("dropCollect");
	return {
		connectDropTarget: connect.dropTarget(),
		hovered: monitor.isOver({ shallow: true })
	}
}


function mapStateToProps(state) {
	return {
		reduxData: state.scaffoldData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.scaffold.setAttributeByObj(obj));
		},
		addScaffold: (obj) => {
			dispatch(actions.scaffold.addScaffold(obj))
		},
		updateScaffold: (obj) => {
			dispatch(actions.scaffold.updateScaffold(obj))
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DropTarget(PMDNDTypes.WINDOW, dropSource, dropCollect)(ScaffoldDesktop))



// WEBPACK FOOTER //
// ./src/components/scaffold/ScaffoldDesktop.js